export default __webpack_public_path__ + "static/media/favicon.e874317c.ico";